var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
window["define"](function (require) {
    //==================================================================================
    //=======================================[ Imports ]================================
    //==================================================================================
    var $ = require('jquery');
    var Promise = require("bluebird");
    var vel = require('velocity');
    var LoadingOverlay = require("libloadingoverlay");
    //=================================================================================
    //=======================================[ Global ]================================
    //=================================================================================
    //Options par défaut
    var _defaults = {
        color: "rgba(224, 224, 224, 0.5)",
        //custom: '<svg width="150" height="150" viewBox="0 18 80 80" class="logoQuantalysLoader" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><image class="quantalys-loader-svg" href="/Areas/Shared/Static/img/Q-3.svg" x="0px" y="21px" width="78%" height="78%"/></svg>',
        custom: "",
        fetchPath: /*"/Areas/Shared/Static/img/Q-3.svg"*/ "/Areas/Shared/Static/img/loader-without-background.gif",
        type: /*'SVG'/**/ 'GIF' /**/,
        RunAnimation: function (container, settings) {
            // si SVG: on fait tourner
            if (settings.type == 'SVG') {
                var $el = $(container).find(".logoQuantalysLoader");
                $el.velocity({ rotateZ: '360deg' }, { duration: 1000, loop: true });
            }
            // si IMG: on fait tourner
            else if (settings.type == ('IMG')) {
                var $el = $(container).find(".logoQuantalysLoader");
                $el.velocity({ rotateZ: '360deg' }, { duration: 1000, loop: true });
            }
            // si GIF: c'est déjà animé, donc pas besoin de faire des animations
        },
        isNotPartenaire: $("#QLoadingOverlayIsNotPartenaire").val()
    };
    $.LoadingOverlaySetup = function (settings) {
        $.extend(true, _defaults, settings);
    };
    $.LoadingOverlay = function (action, options) {
        switch (action.toLowerCase()) {
            case "show":
                var settings = $.extend(true, {}, _defaults, options);
                _Show("body", settings);
                break;
            case "hide":
                _Hide("body", options);
                break;
        }
    };
    $.fn.LoadingOverlay = function (action, options) {
        var self = this;
        return new Promise(function (resolve, reject) {
            switch (action.toLowerCase()) {
                case "show":
                    var settings = $.extend(true, {}, _defaults, options);
                    self.each(function () {
                        _Show(this, settings);
                    });
                    break;
                case "hide":
                    self.each(function () {
                        _Hide(this, options);
                    });
            }
            setTimeout(resolve, 20); //to do
        });
    };
    function _Show(container, settings) {
        var isNotPartenaireQuantalys = (_defaults.isNotPartenaire === "true");
        if (isNotPartenaireQuantalys) {
            settings.fontawesome = "";
            settings.maxSize = "90px";
            settings.minSize = "30px";
            settings.size = "100%";
            fetchLoaderContentAndRunAnimation(container, settings);
        }
        else
            $(container).LibLoadingOverlay("show", settings);
    }
    function _Hide(container, force) {
        $(container).LibLoadingOverlay("hide", force);
    }
    var fetchLoaderContentAndRunAnimation = function (container, settings) {
        if (settings.type == 'SVG') {
            fetchAsyncSVGContent(container, settings).then(function () {
                $(container).LibLoadingOverlay("show", settings);
                _defaults.RunAnimation(container, settings);
            }).catch(function () { console.log("Error on fetching overlayloading"); });
        }
        else if ((settings.type == 'IMG') || (settings.type == 'GIF')) {
            // on assigne directment le fetchPath au custom, qui est donc de la forme <img src="imgExample.gif" />
            settings.image = settings.fetchPath;
            // puis on va run l'animation
            _defaults.RunAnimation(container, settings);
            $(container).LibLoadingOverlay("show", settings);
        }
    };
    function fetchAsyncSVGContent(container, settings) {
        return __awaiter(this, void 0, void 0, function () {
            var response, responseContent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(settings.fetchPath)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        responseContent = _a.sent();
                        settings.custom = responseContent;
                        // puis on va run l'animation
                        _defaults.RunAnimation(container, settings);
                        if (!response.ok)
                            return [2 /*return*/, Promise.reject(responseContent)];
                        return [2 /*return*/, responseContent];
                }
            });
        });
    }
});
//# sourceMappingURL=quantaloadingoverlay.js.map